module.exports = __webpack_public_path__ + "img/em-tao-process-04.efa1e1d1.webp";